import { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { setPendingChallenge } from '../auth/pendingChallenge';
import Footer from '../components/Footer';

export default function Login() {
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/';

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const passwordResetSuccess = location.state?.passwordResetSuccess;

  async function handleSubmit(e) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const result = await signIn(email, password);
      if (result.newPasswordRequired) {
        // Admin-created accounts (see template.yaml AdminCreateUserConfig)
        // start with a temporary password and Cognito forces a reset on
        // first login. Handled as a real route (/set-new-password), not an
        // inline form here. The challenge object goes through a plain
        // module-scoped singleton (pendingChallenge.js), NOT navigate's
        // own `state` option - CognitoUser instances hold a Storage
        // reference internally, which history.pushState() (what `state`
        // uses under the hood) can't structured-clone, and throws at
        // navigation time if you try.
        setPendingChallenge({ user: result.user, userAttributes: result.userAttributes, from });
        navigate('/set-new-password');
        return;
      }
      navigate(from, { replace: true });
    } catch (err) {
      setError(err.message || 'Sign in failed.');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="auth-page d-flex flex-column min-vh-100">
      <div className="flex-grow-1 d-flex align-items-center justify-content-center">
        <div className="card auth-card shadow-sm border-0">
          <div className="auth-accent-bar" />
          <div className="card-body">
            <div className="text-center mb-4">
              <img src="/bizmo-logo.png" alt="Bizmoto" height="44" />
            </div>
            <form onSubmit={handleSubmit}>
              <h1 className="h5 text-center mb-1">Welcome back</h1>
              <p className="text-muted small text-center mb-3">Sign in to the P2M callback dashboard</p>
              {passwordResetSuccess && (
                <p className="text-success small text-center">
                  Password reset. Sign in with your new password.
                </p>
              )}
              <div className="mb-3">
                <label className="form-label small">Email</label>
                <input
                  type="email"
                  className="form-control"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoComplete="username"
                />
              </div>
              <div className="mb-3">
                <label className="form-label small">Password</label>
                <input
                  type="password"
                  className="form-control"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  autoComplete="current-password"
                />
              </div>
              {error && <p className="text-danger small">{error}</p>}
              <button type="submit" className="btn btn-primary w-100" disabled={submitting}>
                {submitting ? 'Signing in…' : 'Sign in'}
              </button>
              <p className="text-center small mt-3 mb-0">
                <Link to="/forgot-password">Forgot password?</Link>
              </p>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
